import {
  createUpdateInfiniteDataRecipe,
  createUpdateSingleItemRecipe,
} from '@autone/utils';

import {
  type TransformedAssortmentProductLocationsItem,
  type TransformedAssortmentProductLocationsResponse,
} from '../schemas/get-assortment-product-locations.schema';

import { type RowIdentifiersLoc } from './types';

export const createUpdateProductlocationAggregateValuesRecipe = (
  { locationId }: RowIdentifiersLoc,
  updatedProductLocation: TransformedAssortmentProductLocationsItem,
) =>
  createUpdateInfiniteDataRecipe(
    createUpdateSingleItemRecipe<TransformedAssortmentProductLocationsResponse>(
      {
        predicate: (item) => item.location.id === locationId,
        updateRecipe: (item) => {
          item.initial_allocation.value =
            updatedProductLocation.initial_allocation.value;
          item.sku_counts.assorted = updatedProductLocation.sku_counts.assorted;
        },
      },
    ),
  );
